import React from 'react';
import { Card } from "react-bootstrap";
import face_christopher_stapenhurst from "../../assets/img/face_christopher_stapenhurst.jpg";
import face_fatma_aslan from "../../assets/img/face_fatma_aslan.jpg";
import ShowMoreText from "react-show-more-text";
import proj_electric_scooters from "../../assets/img/proj_electric_scooters.png";

const F_Aslan_and_Ch_Stapenhurst_strat = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_electric_scooters} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_fatma_aslan}
              
            />{" "}
            <p className="text7">Fatma Aslan</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_christopher_stapenhurst}
              
            />{" "}
            <p className="text7">Christopher Stapenhurst</p>
            <br />
            <p className="text8">
              Postdoctoral <br/>Researcher{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Department of Management and Business Economics, BME </p>
            </div>
            <div>
            <p className="text8">QSMS Research Group, BME </p>
            </div>
            <div>
            Chaudhury and Papai (2024) develop efficient and stable algorithms for matching students 
            to schools with affirmative action policies. But these algorithms are not strategy proof 
            --- students may be able to get to their preferred school by misreporting their preferences. 
            The goal of this project is to study whether randomising over non-strategy proof matching 
            algorithms can produce a strategy proof algorithm. The ideal student should be comfortable 
            with algorithms. Knowledge of programming and game theory are helpful but not required. 
            Chaudhury and Papai (2024) is available 
            <a href="https://www.mktudegy.hu/wp-content/uploads/2024/05/IA-DA_WP-May-2024.pdf">here</a>.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default F_Aslan_and_Ch_Stapenhurst_strat;